module.exports = __webpack_public_path__ + "static/media/entree-desk.4533431b.svg";